module.exports = __webpack_public_path__ + "img/pa.01a071ec.jpg";